module.exports = __webpack_public_path__ + "static/media/udacityLogo.8516f97e.png";